<template>
    <section class="how-it-works">
        <div class="container">
            <div class="row justify-content-lg-between">
                <div class="col-md-12">
                    <h2 class="display md font manrope-semibold f-w-600 mb-24">
                        Peekage features
                    </h2>
                </div>
                <div class="col-md-12 pt-24 mt-52">
                    <div class="row">
                        <div v-for="(feature, i) in features"
                             :key="i"
                             class="col-md-6 mb-36"
                        >
                            <div class="d-flex justify-content-start">
                                <a class="image-container mr-12 py-22 px-22">
                                    <img :alt="feature.alt" :src="$image(feature.image)" width="32" height="32">
                                </a>
                                <div>
                                    <h6 class="heading x-sm font f-w-600">
                                        {{ feature.title }}
                                    </h6>
                                    <span class="text sm font font-normal">{{ feature.subtitle }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data () {
        return {
            features: [
                { alt: 'Product strategy', image: 'arts/Targeting.svg', title: 'Product strategy', subtitle: 'A professional team of marketers, charting the best route for your brand.' },
                { alt: 'Product Specialists', image: 'arts/Collect Data.svg', title: 'Product Specialists', subtitle: '+1XXX consumers, verified and active across Canada to provide feedback. Opt-in method, users choose products.' },
                { alt: 'Campaign managing', image: 'arts/Opt-in.svg', title: 'Campaign managing', subtitle: 'Hands on group of managers, measuring and adjusting your campaign in real time, making targeting easy.' },
                { alt: 'Data analysis', image: 'arts/reviews-lg.svg', title: 'Data analysis', subtitle: 'Gathering data, and transforming it into usable information instantaneously, for changing or maintaining ad channels.' },
                { alt: 'Inventory managing', image: 'arts/Fulfilment.svg', title: 'Inventory managing', subtitle: 'Package tracking and status checking of your products. Shipping and fulfillment made easy.' },
                { alt: 'Reports', image: 'arts/Data.svg', title: 'Reports', subtitle: 'Real-time analytical reports available for each product or campaign, usable for retargeting. ' },
            ],
        };
    },
};
</script>
